import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Collapse, Card, Icon } from 'antd';

import { tipusCampNoSuportat } from '../../constants';

import VariableText from '../commons/variableText';
import VariableLlista from '../commons/variableLlista';
import VariableNumeric from '../commons/variableNumeric';
import VariableData from '../commons/variableData';
import VariableBoolea from '../commons/variableBoolea';
import EstacioIntroduccioMetadadesSelectorMetadada from './estacioIntroduccioMetadadesSelectorMetadada';

import {
    estacioIntroduccioAfegirMetadada,
    estacioIntroduccioModificarMetadada,
    estacioIntroduccioEliminarMetadada
} from '../../actions';

import {
    selectorMetadadesDisponiblesPerGrup,
    selectorMetadadesEditadesAmbEstructura
} from '../../selectors/selector_estacio_formulari_dades';

const Panel = Collapse.Panel;
const estilsSelector = {
    contenidor: 'estacio_metadades_introduccio_variable_llista',
    selector: 'estacio-introduccio-metadades-selector'
};

class EstacioIntroduccioMetadades extends Component {

    renderitzarCampSegonsTipus(idMetadada, camp) {
        const onChangeValorVariable = (valor) => {
            this.props.estacioIntroduccioModificarMetadada(idMetadada, camp.id, valor);
        };

        switch (camp.tipus) {
            case 2:
                return <VariableText
                    key={camp.id}
                    variable={camp}
                    estilsDiv={'estacio_metadades_introduccio_variable_text'}
                    onChangeValorVariable={onChangeValorVariable} />;
            case 3:
                return <VariableLlista
                    key={camp.id}
                    estils={estilsSelector}
                    variable={camp}
                    onChangeValorVariable={onChangeValorVariable}
                    allowClear={true} />;
            case 4:
                return <VariableNumeric
                    key={camp.id}
                    variable={camp}
                    estilsDiv={'estacio_metadades_introduccio_variable_number'}
                    onChangeValorVariable={onChangeValorVariable} />;
            case 6:
                return <VariableData key={camp.id} variable={camp} onChangeValorVariable={onChangeValorVariable} />;
            case 8:
                return <VariableBoolea
                    key={camp.id}
                    variable={camp}
                    estilsDiv={'estacio_metadades_introduccio_variable_checkbox'}
                    onChangeValorVariable={onChangeValorVariable} />;
            default:
                return <div key={camp.id}><span>{camp.nom}:</span> {tipusCampNoSuportat}</div>;
        }
    }

    renderitzarMetadades(metadades) {
        return metadades.map(metadada => {
            const idMetadada = metadada.id;
            return (
                <Card
                    className='estacio-metadades-caixa-metadada'
                    key={idMetadada}
                    title={metadada.nom}
                    extra={
                        <Icon
                            type='delete'
                            className='icona-eliminar-sense-margin icona-eliminar'
                            onClick={() => this.props.estacioIntroduccioEliminarMetadada(idMetadada)} />
                    }>
                    {metadada.camps.map(camp => this.renderitzarCampSegonsTipus(idMetadada, camp))}
                </Card>
            );
        });
    }

    renderitzarGrups(grups, variablesAMostrarComMetadades) {
        return grups.map(grup => {
            const idGrup = grup.id;
            return (
                <Panel header={grup.nom} key={idGrup}>
                    <EstacioIntroduccioMetadadesSelectorMetadada
                        idGrup={idGrup}
                        valorsPossibles={variablesAMostrarComMetadades[idGrup]}
                        afegirMetadadaAGrup={this.props.estacioIntroduccioAfegirMetadada} />
                    {this.renderitzarMetadades(grup.metadades)}
                </Panel>
            );
        });
    }

    render() {
        const { dades, variablesAMostrarComMetadades } = this.props;
        return (
            <Collapse bordered={false}>
                {this.renderitzarGrups(dades, variablesAMostrarComMetadades)}
            </Collapse>
        );
    }
}

EstacioIntroduccioMetadades.propTypes = {
    dades: PropTypes.array,
    variablesAMostrarComMetadades: PropTypes.object,
    estacioIntroduccioAfegirMetadada: PropTypes.func,
    estacioIntroduccioModificarMetadada: PropTypes.func,
    estacioIntroduccioEliminarMetadada: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        dades: selectorMetadadesEditadesAmbEstructura(state),
        variablesAMostrarComMetadades: selectorMetadadesDisponiblesPerGrup(state)
    };
};

const mapDispatchToProps = {
    estacioIntroduccioAfegirMetadada,
    estacioIntroduccioModificarMetadada,
    estacioIntroduccioEliminarMetadada
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioMetadades);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioMetadades.js